import {
  object,
  array,
  number,
  string,
  date,
  // bool,
} from 'yup';

import mergeSchemas from '../../../utilities/mergeSchemas';


export const naturalPersonValidationSchema = object().shape({
  name: object().shape({
    firstName: string().required().label('First name'),
    lastName: string().required().label('Last name'),
  }),
  birthDate: date().required().label('Date of birth'),
  // isPolitician: bool().required().label('Politically exposed person'),
  nationalityId: number().required().label('Nationality'),
  identifications: array().of(
    object().shape({
      number: string().required().label('Identification number'),
    }),
  ),
});

export const legalEntityValidationSchema = object().shape({
  name: object().shape({
    fullName: string().required().label('Company name'),
  }),
  companyType: string().required().label('Company Type'),
  identifications: array().of(
    object().shape({
      number: string().required().label('Company number'),
    }),
  ),
});

export const watchListEntryCommonValidationSchema = object().shape({
  type: number().required(),
  addresses: array().of(
    object().shape({
      countryId: number().required().label('Country'),
    }),
  ),
  comment: string().required().label('Comment'),
});

export const watchListNaturalPersonEntryValidationSchema = mergeSchemas(
  naturalPersonValidationSchema,
  watchListEntryCommonValidationSchema,
);

export const watchListLegalEntityEntryValidationSchema = mergeSchemas(
  watchListEntryCommonValidationSchema,
  legalEntityValidationSchema,
);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/validation-schemas/watchListEntryValidationSchema.js